import React from "react";
import ClickToCopyWrapper from "../common/ClickToCopyWrapper";
import UnitHasParentModal from "./UnitHasParentModal";

class UnitHasParentButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  render() {
    const { isModalOpen } = this.state;
    const { unit, networkId, networkName, isLabelOnly } = this.props;

    const parentUnits = unit.parent_units || unit.parentUnits || [];

    return (
      <>
        <div
          className={`flex items-center gap-1 ${
            isLabelOnly ? "" : "cursor-pointer"
          }`}
        >
          <span
            className={`font-bold text-orange-800 ${
              isLabelOnly ? "" : "hover:underline"
            }`}
            onClick={() => {
              if (isLabelOnly) return;
              this.setState({ isModalOpen: true });
            }}
          >
            Child
          </span>
          <ClickToCopyWrapper
            copyText={parentUnits.join(", ")}
            tooltipMessage="Click to copy parent unit ID"
          ></ClickToCopyWrapper>
        </div>

        {isModalOpen && !isLabelOnly && (
          <UnitHasParentModal
            unit={unit}
            networkId={networkId}
            networkName={networkName}
            handleClose={() => this.setState({ isModalOpen: false })}
          ></UnitHasParentModal>
        )}
      </>
    );
  }
}

export default UnitHasParentButton;
